enum UserRoleTypes {
  Admin = 1,
  VenueEditor = 2,
  CommerceEditor = 3,
  Buyer = 4,
}

export default UserRoleTypes;
